// extracted by mini-css-extract-plugin
export default {"Badge":"_Badge--rrzk7","type":"_type--IRQzS","name":"_name--V_gz2","outline":"_outline--VN2j4","lightGray":"_lightGray--M6XHw"};